import { render, staticRenderFns } from "./trade-deficit-mp1c.vue?vue&type=template&id=41279e9e&"
import script from "./trade-deficit-mp1c.vue?vue&type=script&lang=js&"
export * from "./trade-deficit-mp1c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
